import { Button, Segment } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import { ModeReglementContext } from '@/contexts';
import type { RegieModeReglement } from '@/types/regie';
import ModalRegieModesReglement from './ModalRegieModesReglement';

type ModesReglementProps = {
  depotFondTresor?: boolean;
  modesReglements?: RegieModeReglement[];
  onChange?: (modes: any) => void;
};

const ModesReglement = (props: ModesReglementProps) => {
  const { onChange, depotFondTresor, modesReglements } = props;

  const [modesReglementModalOpen, setModesReglementModalOpen] = React.useState(false);

  const { regieModesReglement } = React.useContext(ModeReglementContext);

  const handleValidate = React.useCallback(
    (modes) => {
      if (onChange) {
        onChange(modes);
      }

      setModesReglementModalOpen(false);
    },
    [onChange],
  );

  /**
   * S'il y a quelque chose dans le state de la fiche, on s'en sert, c'est qu'il y a eu modification
   * Sinon on prend ce qu'il y a dans ModeReglementContext
   */
  const modesAffiches = React.useMemo(() => {
    if (modesReglements) {
      return modesReglements;
    }

    return regieModesReglement;
  }, [modesReglements, regieModesReglement]);

  return (
    <div
      style={{
        marginTop: '-2em',
        display: 'flex',
        alignItems: 'end',
        flexDirection: 'column',
      }}
    >
      <Button
        secondary
        style={{ borderBottom: 0, width: 'fit-content' }}
        attached="top"
        data-testid="add-button-mode-reglement"
        content="Sélectionner les modes de règlement autorisés"
        icon="pencil"
        onClick={() => setModesReglementModalOpen(true)}
      />
      <Segment
        className="half right"
        attached="bottom"
        style={{
          margin: 0,
          padding: '0.75em',
          display: 'flex',
          gap: '0.75em',
          flexWrap: 'wrap',
        }}
      >
        {_.map(modesAffiches, (mode) => (
          <Button
            key={`mode-${mode.identifiant}`}
            // basic
            secondary
            size="small"
            style={{ pointerEvents: 'none', minWidth: 225 }}
          >
            {mode.libelle}
          </Button>
        ))}
      </Segment>
      {modesReglementModalOpen && (
        <ModalRegieModesReglement
          selectedModes={modesAffiches}
          depotFondTresor={depotFondTresor}
          onClose={() => setModesReglementModalOpen(false)}
          onValidate={handleValidate}
        />
      )}
    </div>
  );
};

export default ModesReglement;
